import './dashboard.css';
import DashboardTable from './dashboardTable/DashboardTable';
import { useCallback, useEffect, useState } from 'react';
import errorHandle from '../../utils/errorHandle';
import ReactLoading from 'react-loading';
import { dashboardCount, getCustomTableData, getKpiData, getTableData } from './dashboardFun/fetchDashboardData';
import { toPascalCase } from '../../utils/pascalCase';
import EmptyPage from '../../components/empty-page/emptyPage';
import Pagination from '../../components/pagination/Pagination';
import DashboardTableCustom from './dashboardTableCustom/DashboardTableCustom';
import { useSearchParams } from 'react-router-dom';

export default function Dashboard() {
    const [tableData, setTableData] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const selected = searchParams.get('type') || 'next';
    const datesType = searchParams.get('datesType') || 'fixed';
    const bookingsOnly = searchParams.get('bookings') || true;
    const pageNumber = Number(searchParams.get('page')) || 1;
    const [loading, setLoading] = useState(false);
    const [kpiData, setKpiData] = useState([]);
    const limit = 10;
    const offSet = (pageNumber - 1) * limit;
    const [totalCount, setTotalCount] = useState(0);
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        dashboardCount(selected, setTotalCount, setLoading);
    }, [selected]);

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    useEffect(() => {
        if (!totalPages) return;

        if (pageNumber > totalPages) {
            updateURL({ page: totalPages });
        }
        //eslint-disable-next-line
    }, [totalPages, pageNumber, updateURL]);

    useEffect(() => {
        async function fetchDashborad() {
            try {
                if (datesType === 'custom') {
                    await getCustomTableData(limit, setTableData, setLoading, offSet, selected, datesType);
                    getKpiData(setKpiData, setLoading, datesType);
                } else {
                    await getTableData(selected, setTableData, bookingsOnly, limit, offSet, setLoading);
                    getKpiData(setKpiData, setLoading, datesType);
                }
                // await getTableData(selected, setTableData, limit, offSet, setLoading);

                // setTableData(table.data);
            } catch (error) {
                setLoading(false);
                errorHandle(error);
            }
        }
        fetchDashborad();
    }, [selected, limit, offSet, datesType, bookingsOnly]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };
    return (
        <div className='dashboard'>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='kpi-container'>
                {kpiData.map((item, index) => (
                    <div className={`kpi-card kpi-card-${index + 1}`} key={index}>
                        <h1>{item.name === 'wallet' ? 'N/A' : item.count}</h1>
                        <h4>{toPascalCase(item.name)}</h4>
                    </div>
                ))}
            </div>
            <div className='DashListOfUpcoming'>
                <div className='customOptions'>
                    <div className='sticky-container'>
                        <select
                            name='date'
                            id='date'
                            className='select'
                            value={selected}
                            onChange={(e) => {
                                updateURL({ type: e.target.value, page: 1 });
                            }}
                        >
                            <option value='next'>Upcoming</option>
                            {datesType === 'fixed' && <option value='today'>Today</option>}
                            <option value='previous'>Completed</option>
                        </select>
                    </div>
                    <div className='sticky-container'>
                        <select
                            name='bookingsOnly'
                            id='bookingsOnly'
                            className='select'
                            value={bookingsOnly}
                            onChange={(e) => {
                                updateURL({ bookings: e.target.value, page: 1 });
                            }}
                        >
                            <option value={false}>All Slots</option>
                            <option value={true}>Bookings Only</option>
                        </select>
                    </div>
                    <div className='sticky-container'>
                        <select
                            name='datesType'
                            id='datesType'
                            className='select'
                            value={datesType}
                            onChange={(e) => {
                                updateURL({ datesType: e.target.value, page: 1 });
                            }}
                        >
                            <option value='fixed'>Fixed</option>
                            <option value='custom'>Custom</option>
                        </select>
                    </div>
                </div>
                {tableData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <>
                        {' '}
                        {datesType === 'fixed' && tableData.length > 0 ? (
                            <DashboardTable tableData={tableData} />
                        ) : (
                            <DashboardTableCustom tableData={tableData} />
                        )}
                        <Pagination
                            paginationClick={paginationClick}
                            numberOfRows={totalData}
                            offSet={offSet}
                            pageNumber={pageNumber}
                            limit={limit}
                        />
                    </>
                )}
            </div>
        </div>
    );
}
